import type { ReactNode } from 'react';
import { Space } from 'antd';

type TableRowActionsProps = {
  children: ReactNode;
  /** Prefer wrap when a row has 3+ actions (e.g. Drivers HQ). */
  wrap?: boolean;
};

/**
 * Shared Actions-column layout for Admin tables.
 * Enforces ≥8px gap between controls (misclick / touch spacing).
 * Prefer `type="link"` buttons as children for visual consistency.
 */
export function TableRowActions({ children, wrap = true }: TableRowActionsProps) {
  return (
    <Space size={8} wrap={wrap} className="admin-table-row-actions">
      {children}
    </Space>
  );
}
